<template>
  <div class="subject-box">
    <div class="subject-box-title">
      <div class="title-left">
       <p class="china-title">{{currentQuestionList1.tips_cnname}}</p>
        <p class="en-title">{{currentQuestionList1.tips_enname}}</p>
      </div>
      <div class="title-right" v-if="currentQuestionList1.has_audio==1">
        <div class="audio-add" @click="playAudio">
          <div class="audio-box" style="position:relative;z-index:10;"></div>
          <audio
            class="audio"
            id="audioPlay"
            ref="audio"
            controls
            :src="currentQuestionList1.question_audio"
            autoplay 
          ></audio>
        </div>
      </div>
    </div>
    <div class="subject-content-box">
      <div class="subject-content">
        <div class="word-box" v-html="currentQuestionList1.question_title"></div>
        <div class="isHasImg tc" v-if="currentQuestionList1.has_img==1" style="margin-bottom:20px;">
          <img :src="currentQuestionList1.question_titleimg" style="max-width:200px;" alt />
        </div>
        <div class="img-box">
           <div class="item" v-for="(item,index) of currentQuestionList1.option" :key="index">
            <input
            @change="iptChange(currentQuestionList1.question_id, item.answers_optionname)"
              type="radio"
              name="one0"
              class="chooseChecked checked"
              :id="`one${currentQuestionList1.question_id}_${index}`"
              :value="item.answers_optionname"
              v-model="anwsersAll.answers"
              disabled
            />
            <label :for="`one${currentQuestionList1.question_id}_${index}`" class="label-box">
              <div class="img">
                <img :src="item.answers_optionimg" alt />
                <!-- <span class="chooseChecked checked" v-if="question.Index==index && question.flag"></span> -->
              </div>
              <span class="option">{{item.answers_optionname}}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PictureSelection",
    props: {
    currentQuestionList: {
      type: Object
    },
    //当前点击到 第几题
    currentId: {
      type: Number
    },
    anwsersAll: {
      type: Object
    },
  },
  data() {
    return {
       currentQuestionList1: {},
      currentQuestionClick: "", //当前点击到第几题
      picked: [],
      question: {
        Index: -1,
        flag: false
      },
      answerList: [
        // {
        //   answers:'',
        //   question_id:'',
        // }
      ] //存储答案
    };
  },
  // props: ['title'],
  created() {
    this.currentQuestionList1 = this.propChild
      ? this.propChild
      : this.currentQuestionList;
  },
   watch: {
    getData(n, o) {
      this.currentQuestionList1 = n;
      console.log(this.currentQuestionList1, "我接收到的数据 我是图片选择");
    },
  },
  computed: {
    getData() {
      return this.currentQuestionList;
    },
  },
  methods: {
    iptChange (v1, v2) {
     console.log(v1,v2)
    },
    //正则转换
    questionWay(str) {
      console.log(str);
    },
    //选项切换
    changeQuestion(item, index) {
      console.log(item, index);
      this.question.Index = index;
      this.question.flag = !this.question.flag;
    },
    playAudio() {
      console.log(333);
      let audio = this.$refs.audio;
      audio.play();
    },
  }
};
</script>

<style lang="less">
</style>
